"use strict";

import classNames from "classnames";
import React, { Component, PropTypes } from "react";

import InputComponentBase from ".\\InputComponentBase";

/******************************************************************************
** CaptchaInput
*/

export default class CaptchaInput extends InputComponentBase {

	static generateImageUrl(formKey) {
		return "/umbraco/Surface/CaptchaSurface/CaptchaImage?formKey=" + formKey + "&width=120&height=55&ts=" + new Date().getTime();
	}

	constructor(props) {
		super(props);
		this.state = Object.assign(this.state || {}, {
			imageUrl: CaptchaInput.generateImageUrl(props.context.getFormKey())
		});
	}

	updateInputState(inputState) {
		super.updateInputState(inputState);
		if (inputState && !inputState.IsValid) {
			this.setState({
				imageUrl: CaptchaInput.generateImageUrl(this.props.context.getFormKey()),
				value: ""
			});
		}
	}

	render() {
		let label = null;
		if (this.props.showLabel) {
			label = this.renderLabel(this.props.title);
		}
		let placeholder = null;
		if (this.props.showPlaceholder) {
			placeholder = this.props.title;
		}
		let value = this.state.value;
		return (
				<div ref="topContainer" className={this.props.containerClassNames}>
					<div className={classNames(this.props.inputClassNames, { "input-field_error": this.state.isError })}>
						<div className="input-field__wrapper">
							{label}

							<img className="input-field__img" src={this.state.imageUrl} alt="CAPTCHA" />
							<input ref="input" type="text" className="input-field__input" id={this.state.clientId} name={this.state.inputName} placeholder={placeholder} value={value}
									autoComplete="off"
									onFocus={this._onFocus} onBlur={this._onBlur}
									onChange={this._onChange} onInput={this._onInput} onSubmit={this._onSubmit}
									/>
						</div>
						{this.renderErrorMessageCtrl()}
					</div>
				</div>
			);
	}
}



/** WEBPACK FOOTER **
 ** ./forms/CaptchaInput.jsx
 **/